import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=76f1f88d&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=76f1f88d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1f88d",
  null
  
)

export default component.exports